import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { apiKey } from '../../utils/ktcUtils';
import QRCodeGenerator from '../../components/QRCodeGenerator';

const purple = '#6A1B9A'; // Kaafiye color example

export default function KaafiyeIDCard() {
  const { id } = useParams();
  const [users, setUsers] = useState(null);
  console.log('id:', id);

  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/generate-id/${id}`;
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setUsers(data.report);
      });
  }, [id]);
  console.log('user:', users);
  if (!users) return <div>Loading...</div>;
  // Function to replace last part of the URL with user.id
  const getUserURL = (userId) => {
    const url = new URL(window.location.href);
    const paths = url.pathname.split('/').filter(Boolean); // split path
    paths[paths.length - 1] = userId; // replace last part with user.id
    url.pathname = '/' + paths.join('/');
    return url.toString();
  };
  const printStyles = `
@media print {

  @page {
    size: 1050px 600px;
    margin: 0;
  }

  body {
    margin: 0;
    padding: 0;
  }

  .print-page {
    width: 1050px;
    height: 600px;
    page-break-after: always;
  }

}
`;
  return (
    <>
      <style>{printStyles}</style>

      <div>
        {users.map((user, index) => (
          <React.Fragment key={index}>
            {/* FRONT PAGE */}
            <div style={styles.page} className="print-page">
              <div style={styles.card}>
                <img
                  src="/id/ktc-id-front.jpeg"
                  alt="Front ID"
                  style={styles.bg}
                />

                <img
                  src={`${API_URL}/${user.image}`}
                  alt="User"
                  style={styles.img}
                />

                <div style={styles.content}>
                  <h2 style={styles.name}>{user.name}</h2>
                  <div style={styles.job}>{user.job_title}</div>

                  <div style={styles.info}>
                    <div style={styles.row}>
                      <span style={styles.label}>ID:</span>
                      <span style={styles.value}>{user.id}</span>
                    </div>

                    <div style={styles.row}>
                      <span style={styles.label}>Sex:</span>
                      <span style={styles.value}>{user.sex}</span>
                    </div>

                    <div style={styles.row}>
                      <span style={styles.label}>Blood Group:</span>
                      <span style={styles.value}>{user.blood_group}</span>
                    </div>

                    <div style={styles.row}>
                      <span style={styles.label}>Issue Date:</span>
                      <span style={styles.value}>{user.issue_date}</span>
                    </div>

                    <div style={styles.row}>
                      <span style={styles.label}>Expire Date:</span>
                      <span style={styles.value}>{user.expire_date}</span>
                    </div>
                  </div>
                </div>

                <div style={styles.qrcode}>
                  <QRCodeGenerator url={getUserURL(user.id)} />
                </div>
              </div>
            </div>

            {/* BACK PAGE */}
            <div style={styles.page}>
              <div style={styles.card}>
                <img
                  src="/id/ktc-id-back.jpeg"
                  alt="Back ID"
                  style={styles.bg}
                />
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </>
  );
}

const styles = {
  page: {
    width: '1050px',
    height: '600px',
    margin: 0,
    padding: 0,
    pageBreakAfter: 'always',
  },

  card: {
    position: 'relative',
    width: '1050px',
    height: '600px',
  },

  bg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  img: {
    position: 'absolute',
    top: '175px',
    left: '130px',
    width: '248px',
    height: '248px',
    objectFit: 'cover',
    borderRadius: '20px',
  },

  content: {
    position: 'absolute',
    top: '90px',
    left: '430px',
    color: '#6A1B9A',
  },

  name: {
    fontWeight: 'bold',
    fontSize: '35px',
    margin: 0,
    padding: 0,
    lineHeight: '45px',
  },

  job: {
    fontSize: '24px',
    margin: 0,
    padding: 0,
    lineHeight: '28px',
    opacity: 0.8,
  },

  info: {
    fontSize: '25px',
    lineHeight: '36px',
    margin: 0,
    padding: 0,
    marginTop: '40px',
  },

  row: {
    display: 'flex',
    margin: 0,
    padding: 0,
    alignItems: 'center',
  },

  label: {
    width: '220px',
    fontWeight: 'bold',
    margin: 0,
    padding: 0,
  },

  value: {
    fontWeight: 'bold',
    margin: 0,
    padding: 0,
  },

  qrcode: {
    position: 'absolute',
    bottom: '20px',
    right: '70px',
    width: '130px',
    height: '130px',
  },
};
